import React, { useState } from 'react';
import {
  Input, Card, Table, Button, Breadcrumb, Col, Row, Space, Spin, Select
} from 'antd';
import { useTranslation } from 'react-i18next';   
import { faMicrochip, faSearch } from '@fortawesome/free-solid-svg-icons';
import { FallOutlined, FilterOutlined, PieChartOutlined, PlusOutlined, RiseOutlined, SearchOutlined } from '@ant-design/icons';
import Chart from 'react-apexcharts';
import {
  ResponsiveContainer,
} from 'recharts';

import MainLayout from '@common/layouts/MainLayout';
import withAuth from '@common/hocs/withAuth';
import CenteredContent from '@common/components/ui/CenteredContent';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';

import Map from '@common/components/map/GoogleMap';
 

import styles from './DashboardVisitante.module.less';
import useDashboardVisitante from './useDashboardVisitante';

const style = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  marginBottom: 25,
  marginTop: 25,
  cursor: 'pointer',
}; 
 
const { Search } = Input;
const { Option, OptGroup } = Select;

function DashboardVisitante() {

  const { t } = useTranslation();
  const {
    loading, loadingBusiness,
    dataSource,
    columns,
    optionsGraphG1,
    seriesGraphG1,
    optionsGraphG2,
    seriesGraphG2,

  } = useDashboardVisitante();
 

  return (
    <div>
      <div className={styles.fields_wrapper} />
      <Row gutter={[16, 8]}>
        <Col xs={{span: 24}} sm={{span: 24}} md={{span: 12}} lg={{span: 12}} xl={{span: 12}}
        >
            <div style={{
              background: '#fff',
              padding: 25,
              minHeight: '320px',
              height: 'fit-content',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center', 
            }}>
              <div style={{ /* Remove unnecessary `justifyContent` property */ }}>
                <Row gutter={[16, 8]} style={{ fontSize: 20, fontWeight: 'bold', marginBottom: 10 }}>
                  <Col span={8} className="text-right" style={{ color: '#8c8c8c', fontSize: 24, fontWeight: 'bold' }}>
                    <div className={styles.circle_icon_container}>
                      <FontAwesomeIcon icon={faMicrochip} style={{ fontSize: 20, color: '#ffffff' }} />
                    </div>
                  </Col>
                  <Col span={16}>
                    <Row style={{ color: '#8c8c8c', fontSize: 24, fontWeight: 'bold' }}>
                      Boca del palo
                    </Row>
                    <Row style={{ fontSize: '14px', color: '#8c8c8c' }}>
                      <Breadcrumb className="date_wrapper">
                        <Breadcrumb.Item className="breadcrumb">
                          <Link to="/">{t('menu_items.main.home')}</Link>
                        </Breadcrumb.Item>
                        <Breadcrumb.Item className="breadcrumb">
                          Boca del palo
                        </Breadcrumb.Item>
                      </Breadcrumb>
                    </Row>
                  </Col>
                </Row>
                <p className="text-center" style={{ color: '#8c8c8c' }}>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                </p>
                <div className="text-center" style={{ padding: 10, borderRadius: 10, textAlign: 'center' }}>
                  <span style={{ fontSize: 14, fontWeight: 'bold', margin: '0 0.5rem' }}>
                    Cliente Celsia ID:
                    {' '}
                    10
                  </span>
                  <span style={{ fontSize: 14, fontWeight: 'bold', margin: '0 0.5rem' }}>
                    Estrato:
                    {' '}
                    4
                  </span> 
                </div>
              </div>
            </div>

        </Col> 

        <Col xs={{span: 24}} sm={{span: 24}} md={{span: 12}} lg={{span: 12}} xl={{span: 12}}
        >
          <div style={{  background: '#fff', padding: 25, minHeight: '320px', height: 'fit-content'  }}
          >
            <div className="container_map" style={{height:'260px'}}>
              <Map>
                <></>
              </Map>
            </div>
          </div>
        </Col>
      </Row>

      <Row gutter={[16, 8]}>
        <Col span={24}>
          <Row>
            <Card className={styles.tables}>
              <ResponsiveContainer width="100%">
                <div className={styles.tables}>
                  <Row className={styles.headerTables} gutter={[8, 8]}>

                    <Col xs={{span: 24,order: 1, }} sm={{span: 24,order: 1, }} md={{span: 14,order: 2, }} lg={{span: 14,order: 2, }} xl={{span: 14,order: 2, }}
                    >
                      <Input
                        placeholder={t('common.find')}
                        className={styles.search} 
                        // onChange={onChangeSearch}
                        suffix={<FontAwesomeIcon icon={faSearch} />}
                        allowClear
                      />
                    </Col> 

                    <Col
                      className="select-filter"
                      xs={{ span: 24, order: 2}} sm={{ span: 24, order: 2}} md={{ span: 6, order: 3}} lg={{ span: 6, order: 3}} xl={{ span: 6, order: 3}}
                    >
                      <Select
                        defaultValue="todos"
                        className={styles.select_device} 
                        options={[
                          {
                            value: 'todos',
                            label: t('common.show_all'),
                          },
                          {
                            value: 'conectados',
                            label: t('common.connected'),
                          },
                          {
                            value: 'desconectados',
                            label: t('common.disconnected'),
                          },
                        ]}
                      />
                    </Col> 

                    <Col
                      xs={{
                        span: 24,
                        order: 4,
                      }}
                      sm={{
                        span: 24,
                        order: 4,
                      }}
                      md={{
                        span: 4,
                        order: 4,
                      }}
                      lg={{
                        span: 4,
                        order: 4,
                      }}
                      xl={{
                        span: 4,
                        order: 4,
                      }}
                    >
                      <Button type="primary" className={styles.btn_create}  >
                        Generar reporte
                      </Button>
                    </Col>

                  </Row>
                </div>
              </ResponsiveContainer>
            </Card>
          </Row>
          
          <Row gutter={[16, 8]}>
            <Col span={24} >
              <Card style={{ width: '100%',marginTop:6 }}>

                <Row>
                  <Col span={24}>
                    <span className='miga_title' style={{fontSize:18}}>Resumen</span> <span className={styles.cardText}>Total acumulado</span> 
                  </Col>
                </Row>

                <Row>
                  
                  <Col xs={24} sm={24} md={12} lg={8} xl={8}>
                    <div className={styles.cardCustom}>
                      <RiseOutlined  style={{fontSize:25, color:'#ff812e'}} /> <span className='miga_title'>420.000</span> <span className={styles.cardText}>kwh</span><br></br>
                      <span>Energía solar generada</span>
                    </div>
                  </Col>

                  <Col xs={24} sm={24} md={12} lg={8} xl={8}>
                  <div className={styles.cardCustom}>
                      <FallOutlined  style={{fontSize:25, color:'#39587d'}} /> <span className='miga_title'>284.430</span> <span className={styles.cardText}>kwh</span><br></br>
                      <span>Energía Consumida</span>
                    </div>
                  </Col>

                  <Col xs={24} sm={24} md={12} lg={8} xl={8}>
                    <div className={styles.cardCustom}>
                      <RiseOutlined  style={{fontSize:25, color:'#ff812e'}} /> <span className='miga_title'>135.570</span> <span className={styles.cardText}>kwh</span><br></br>
                      <span>Energía solar reservada</span>
                    </div>
                  </Col>
                  
                </Row>

                <Row>
                  
                  <Col xs={24} sm={24} md={12} lg={8} xl={8}>
                    <div className={styles.cardCustom}>
                      <RiseOutlined  style={{fontSize:25, color:'#ff812e'}} /> <span className='miga_title'>753.400.403</span> <span className={styles.cardText}>cop</span><br></br>
                      <span>Ganancias generadas</span>
                    </div>
                  </Col>

                  <Col xs={24} sm={24} md={12} lg={8} xl={8}>
                  <div className={styles.cardCustom}>
                      <span className='miga_title'>12.78</span> <span className={styles.cardText}>ton</span><br></br>
                      <span>Total C02 reducido</span>
                    </div>
                  </Col>

                  <Col xs={24} sm={24} md={12} lg={8} xl={8}>
                    <div className={styles.cardCustom}>
                      <span className='miga_title'>12</span> <span className={styles.cardText}></span><br></br>
                      <span>Total dispositivos </span>
                    </div>
                  </Col>
                  
                </Row>
              </Card>
            </Col>
          </Row>

          <Row gutter={[16, 8]}>
            <Col span={24} >
              <Card style={{ width: '100%' }}>

                <Row>
                  <Col span={24}>
                    <span className='miga_title' style={{fontSize:18}}>Tabla de liquidaciones</span> 
                  </Col>
                </Row> 

                <Row> 
                  <Col span={24}>
                    <Table dataSource={dataSource} columns={columns} width={'100%'} />
                  </Col>
                </Row>
              </Card>
            </Col>
          </Row>

          <Row gutter={[16, 8]}>
            <Col span={12}>
              <Card style={{ width: '100%' }}>

                <Row>
                  <Col span={24}>
                    <span className='miga_title' style={{fontSize:18}}>Energía solar generada VS consumida</span> 
                  </Col>
                </Row> 

                <Row> 
                  <Col span={24}>
                    <Chart
                        className="container-graph-third"
                        options={optionsGraphG1}
                        series={seriesGraphG1}
                        height={370}
                        width="100%"
                        type="donut"
                      />
                  </Col>
                </Row>
              </Card>
            </Col>

            <Col span={12}>
              <Card style={{ width: '100%' }}>

                <Row>
                  <Col span={24}>
                    <span className='miga_title' style={{fontSize:18}}>Energía solar generada</span> 
                  </Col>
                </Row> 

                <Row> 
                  <Col span={24}>
                    <Chart
                      className="container-graph-third"
                      options={optionsGraphG2}
                      series={seriesGraphG2}
                      width="100%"
                      type="area"
                    />
                  </Col>
                </Row>
              </Card>
            </Col>

          </Row>
        

        </Col>
      </Row>
    </div>
  );

}

export default DashboardVisitante;
